import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const Navigation = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 1.5rem;

  button {
    border: 1px solid ${themeGet('colors.border-grey')};
    color: ${themeGet('colors.pc-red')};
    padding: 0.5rem;
    min-width: 71px;
    min-height: 45px;
    font-size: 12px;
    line-height: normal;

    &:hover,
    &:focus {
      text-decoration: underline;
    }
  }

  button.active {
    color: ${themeGet('colors.white')};
    background-color: ${themeGet('colors.pc-red')};
    &:hover,
    &:focus {
      text-decoration: none;
    }
  }

  button:disabled {
    color: ${themeGet('colors.secondary-text')};
    &:hover,
    &:focus {
      text-decoration: none;
    }
  }

  button.first {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  button.last {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  li.mobile-hide {
    display: none;
  }

  li:not(:first-child) {
    margin-top: 0;
  }
`;

export const Button = styled.button``;

export const PageIndication = styled.div`
  align-content: center;
  color: ${themeGet('colors.white')};
  background-color: ${themeGet('colors.pc-red')};
  padding: 0.5rem;
  width: 71px;
  height: 45px;
  border: 1px solid ${themeGet('colors.pc-red')};
  font-size: 12px;
  text-align: center;
`;
